@if (isMessageVisible()) {
    <ng-content />
}
